import React from "react";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import p1 from "assets/images/poze-site/11-1-pardoseli.webp";
import p2 from "assets/images/poze-site/11-2-pardoseli.webp";
import p3 from "assets/images/poze-site/11-3-pardoseli.webp";
import p4 from "assets/images/poze-site/11-4-pardoseli.webp";
import p5 from "assets/images/poze-site/11-5-pardoseli.webp";
import p6 from "assets/images/poze-site/11-6-pardoseli.webp";
import p8 from "assets/images/poze-site/11-8-pardoseli.webp";
import p9 from "assets/images/poze-site/11-9-pardoseli.webp";

const images = [p1, p2, p3, p4, p5, p6, p8, p9];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Întreținere și tratamente speciale pentru pardoseli
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport fix (schimbă la 56.25% pt. 16:9 sau 100% pt. pătrat)
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                    outline: "1px solid rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Pardoseli ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o vizită GRATUITĂ pentru ofertă!
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
